// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1agsH","inner":"Footer_inner__3n7Ov"};